import Checkbox from '@jetbrains/ring-ui/components/checkbox/checkbox'
import classNames from 'classnames'
import * as React from 'react'

import {LoadingContext, DispatchContext} from '../CleanupForm.contexts'
import styles from '../CleanupForm.css'

type OwnProps = {
  value: boolean
}
export const defaultPreserveArtifacts = true

function PreserveDependencies({value}: OwnProps) {
  const disabled = React.useContext(LoadingContext)
  const setValue = React.useContext(DispatchContext)
  const onChange = React.useCallback(
    (values: boolean) =>
      setValue?.({
        name: 'preserveArtifacts',
        value: values,
      }),
    [setValue],
  )
  const changeHandler = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      onChange(event.target.checked)
    },
    [onChange],
  )
  return (
    <div className={classNames(styles.inputs, styles.checkboxContainer, styles.rowGroup)}>
      <div className={styles.checkbox}>
        <Checkbox
          disabled={disabled}
          className={styles.checkbox}
          name={'preserveArtifacts'}
          checked={value}
          onChange={changeHandler}
        >
          {'Keep artifacts in all dependency builds'}
        </Checkbox>
      </div>
    </div>
  )
}

export default React.memo<OwnProps>(PreserveDependencies)
